// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

export let ExternalScreenStorage = function ()
{
    this._storage = new Object();
    this._storageByID = new Object();
}

ExternalScreenStorage.prototype.generateKey = function (name, tb)
{
    return name + "+++" + tb;
}

ExternalScreenStorage.prototype.Clear = function ()
{
    this._storage = new Object();
    this._storageByID = new Object();
}

ExternalScreenStorage.prototype.GetToolData = function (id)
{
    let it = this._storageByID[id]
    if (!it)
        return null;

    let tool = it.tool;

    return { Tool: tool, Text: tool.url, ScreenName: tool.name, Aliases: tool.aliases, ClientTab: tool.clientTab, ClientUseInternalBrowser: tool.useInternalBrowser }
}

ExternalScreenStorage.prototype.GetTool = function (name, clientTab)
{
    let key = this.generateKey(name, clientTab);
    let it = this._storage[key]
    if (!it)
        return null;

    let tool = it.tool;

    return tool;
}

ExternalScreenStorage.prototype.AddItem = function (tool)
{
    let toolById = this._storageByID[tool.id],
        key = this.generateKey(tool.name, tool.clientTab);

    if (!toolById)
    {
        let it = new Object();
        it.scrArray = new Array();
        it.url = tool.url;
        it.tool = tool;

        this._storage[key] = this._storageByID[tool.id] = it;
        return;
    }

    this.UpdateLinkItem(tool);
}

ExternalScreenStorage.prototype.AddScreenItem = function (tool, scr)
{
    let toolById = this._storageByID[tool.id]
    if (!toolById)
        this.AddItem(tool);

    toolById.scrArray.push(scr);
}

ExternalScreenStorage.prototype.UpdateLinkItem = function (tool)
{
    let it = this._storageByID[tool.id];
    if (!it)
        return

    let arr = it.scrArray;
    let newarr = new Array();
    arr.map(function (scr)
    {
        if (!scr.torndown)
        {
            scr.UpdateLink(tool.url, tool.IsNoneLink(), tool);
            newarr.push(scr);
        }
    });


    it.scrArray = newarr;
    it.url = tool.url;
    it.tool = tool;
}

ExternalScreenStorage.prototype.DeleteItem = function (link)
{
    let key = this.generateKey(link.name, link.clientTab);
    let item = this._storageByID[link.id];

    if (item)
    {
        let scrArr = item.scrArray
        for (let i = 0; i < scrArr.length; i++)
            scrArr[i].close()

        item.scrArray = []

        delete this._storageByID[link.id]
        if (this._storage[key])
            delete this._storage[key]
    }
}
